import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkEditClinicActTeam } from '../types';

const onEditClinicActTeam: IThunkEditClinicActTeam = thunk(async (_, { clinicId, actTeam }) => {
  await api.actTeam.editClinicActTeam(clinicId, String(actTeam.id), actTeam);
});

export default onEditClinicActTeam;
